import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { ComponentsModule } from "../../components/components.module";
import { VouchersPage } from "./vouchers";

@NgModule({
  declarations: [VouchersPage],
  imports: [
    IonicPageModule.forChild(VouchersPage),
    TranslateModule.forChild(),
    ComponentsModule,
  ],
  exports: [VouchersPage],
})
export class VouchersPageModule {}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/vouchers.module.ts